import { Link } from "react-router-dom";
import AuthLayout from "../layouts/AuthLayout";

function FacilityRegister() {
  return (
    <AuthLayout
      title="Build a stronger healthcare team."
      description="Create a facility account to request qualified professionals, manage staffing needs and track assignments."
    >
      <div className="auth-card">
        <p className="account-label">Healthcare facilities</p>
        <h2>Create Facility Account</h2>

        <form className="account-form registration-grid">
          <div className="form-field">
            <label htmlFor="facility-name">Facility name</label>
            <input
              id="facility-name"
              name="facilityName"
              type="text"
              required
            />
          </div>

          <div className="form-field">
            <label htmlFor="facility-type">Facility type</label>
            <select id="facility-type" name="facilityType" required>
              <option value="">Select facility type</option>
              <option value="Hospital">Hospital</option>
              <option value="Long-Term Care">Long-Term Care</option>
              <option value="Retirement Home">Retirement Home</option>
              <option value="Clinic">Clinic</option>
              <option value="Home Care">Home Care</option>
              <option value="Community Care">Community Care</option>
            </select>
          </div>

          <div className="form-field">
            <label htmlFor="contact-name">Contact person</label>
            <input
              id="contact-name"
              name="contactName"
              type="text"
              required
            />
          </div>

          <div className="form-field">
            <label htmlFor="job-title">Job title</label>
            <input id="job-title" name="jobTitle" type="text" required />
          </div>

          <div className="form-field">
            <label htmlFor="facility-register-email">
              Work email address
            </label>
            <input
              id="facility-register-email"
              name="email"
              type="email"
              required
            />
          </div>

          <div className="form-field">
            <label htmlFor="facility-phone">Phone number</label>
            <input
              id="facility-phone"
              name="phone"
              type="tel"
              required
            />
          </div>

          <div className="form-field">
            <label htmlFor="facility-city">City</label>
            <input id="facility-city" name="city" type="text" required />
          </div>

          <div className="form-field">
            <label htmlFor="facility-province">Province</label>
            <select
              id="facility-province"
              name="province"
              required
            >
              <option value="">Select province</option>
              <option value="Ontario">Ontario</option>
              <option value="Nova Scotia">Nova Scotia</option>
              <option value="New Brunswick">New Brunswick</option>
              <option value="Manitoba">Manitoba</option>
              <option value="Alberta">Alberta</option>
              <option value="British Columbia">British Columbia</option>
            </select>
          </div>

          <div className="form-field">
            <label htmlFor="facility-register-password">Password</label>
            <input
              id="facility-register-password"
              name="password"
              type="password"
              required
            />
          </div>

          <div className="form-field">
            <label htmlFor="facility-confirm-password">
              Confirm password
            </label>
            <input
              id="facility-confirm-password"
              name="confirmPassword"
              type="password"
              required
            />
          </div>

          <button
            className="primary-button registration-submit"
            type="submit"
          >
            Create Facility Account
          </button>
        </form>

        <div className="account-links auth-account-links">
          <span>Already registered?</span>
          <Link to="/facility/login">Sign in</Link>
        </div>

        <Link className="return-home-link" to="/">
          ← Return to homepage
        </Link>
      </div>
    </AuthLayout>
  );
}

export default FacilityRegister;